module.exports = __webpack_public_path__ + "img/img8.2e9c3916.svg";